export interface SparklinePoint {
  value: number;
}

/**
 * Minimal hand-rolled SVG sparkline. No dependency required.
 * Extracted from EntityTeamCostCard so both cost and DORA cards can share it.
 */
export function Sparkline({
  points,
  color,
}: {
  points: SparklinePoint[];
  color: string;
}) {
  if (points.length < 2) return null;

  const values = points.map(p => p.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;

  const w = 120;
  const h = 36;
  const pad = 2;

  const coords = points.map((p, i) => {
    const x = pad + ((w - pad * 2) * i) / (points.length - 1);
    const y = pad + (h - pad * 2) * (1 - (p.value - min) / range);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width="100%"
      height={h}
      preserveAspectRatio="none"
      style={{ display: 'block' }}
    >
      <polyline
        points={coords.join(' ')}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
